import { styled } from "@health-zelas/delta"

export const Step = styled('div', {
  width: '100%',
  backgroundColor: '#FAFAFA',
  minHeight: '100vh',
  position: 'relative'
})


